<script>
  export let id;
	
  import { Spinner, Input, Disclose, Button,Dialog } from "agnostic-svelte"
  import { store } from "../store"
  import Ex from "./Ex.svelte"
	import {navigate} from 'svelte-routing'
	import {PlanFromCMSPlan} from '../../cms/objects'
  import PriceHeader from "./PriceHeader.svelte"
	import Modal from "../../comps/Modal.svelte"
	

  

  const apikey = "d687412e7b53146b2631dc01974ad0a4"
	
  $: counties = fetch(
    `https://marketplace.api.healthcare.gov/api/v1/counties/by/zip/${store.userd.zip}?apikey=${apikey}`
  ).then((v) => v.json())

  $: plansr = counties.then((counties) => {
    const c = counties.counties?.[0]
    if (!c) {
      console.error("No county found", counties)
      return
    }
    return fetch(
      `https://marketplace.api.healthcare.gov/api/v1/plans/${id}?apikey=${apikey}`,
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          household: {
            income: Number(store.userd.income),
            people: store.userd.people.map((p) => ({
              age: Number(p.age),
              gender: p.sex === "M" ? "Male" : "Female",
            })),
            has_married_couple: store.userd.people.some(
              (p) => p.name === "Spouse"
            ),
          },
          market: "Individual",
          place: {
            countyfips: c.fips,
            state: c.state,
            zipcode: c.zipcode,
          },
        }),
      }
    ).then((v) => v.json()).then(({plan}) => PlanFromCMSPlan(plan))
  })

	let show_enroll=false;
	
</script>

{#await plansr}
  <Spinner />
{:then  plan }
  <div
    class="flex flex-column p8 round container"
    style="max-width: 600px;border: 1px solid var(--agnostic-gray-dark)"
  >
    <h2>{plan.name}</h2>
		<h3 class="p8 round border">${plan.premium}</h3>

    <div style="text-align:left">
      <Ex name="Network type" value={`${plan.premium} per month`}>
        Your premium is the amount you pay for health insurance each month
      </Ex>
      <Ex name="Deductible" value={`${plan.deductible} per month`}>
        <div class="m4">
          Your deductible is the total amount you'll pay for healthcare services
          before your insurance starts to cover a portion of costs. (Scroll down
          to see the specific portion this plan covers for each service.)
        </div>
        <div class="m4">
          However, many plans do cover basic services even before the deductible
          has been met, on day one.
        </div>
        <div class="m4">
          <strong>Note: </strong>
          Monthly premiums don't count towards the deductible totals, and the deductible
          totals reset each year.
        </div>
      </Ex>
      <Ex name="Out-of-pocket max" value={`${plan.pocket_max} per person`}>
        <div class="m4">
          This is the most you'll have to pay for healthcare services during
          your coverage period (typically 12 months) - think of it as your
          safety net in the event of a major health problem.
        </div>
        <div class="m4">
          <strong>Note: </strong>
          Monthly premiums don't count towards your out-of-pocket max.
        </div>
      </Ex>
      <Ex name="Network type" value={plan.network_type}>
        The <a>type of network</a> you choose (HMO, PPO, POS, or EPO) will determine
        which providers (doctors, pharmacies, hospitals, and specialist) you can
        see.
      </Ex>
      <Ex name="Metal tier" value={plan.metal_tier}>
        <a>Metal levels</a> (which include bronze, silver, gold, and platinum) determine
        how you will split the cost of your healthcare services with your insurance
        carrier.
      </Ex>
    </div>
		<Button mode="primary" on:click={()=>{show_enroll=true}}>Enroll</Button>
  </div>
{/await}


<!-- <Dialog id="phone-dialog" dialogRoot="#app-dialogs" closeButtonLabel="My close button label" closeButtonPosition="last" title="We'll call you" role="dialog" classNames={{ title: 'h4 mbe18 flex justify-center' }} isAnimationFadeIn isAnimationSlideUp on:instance={assignDialogInstance} >
	<p class="mbs16 mbe16">
		Tell us your phone number so one of our agents can reach you
	</p>
	<form class="dialog-form-demo">
		<Input isRounded label="Phone (required)" type="phone" id="phone" placeholder="333-333-3333" required />
		<div class="mbe16" />
		<Button type="submit" mode="primary" isRounded isBlock on:click={()=>navigate("/thanks")}>
			Call me
		</Button>
	</form>
</Dialog> -->

{#if show_enroll}
	<Modal on:close={() => show_enroll = false}>
		
		<h3 class="m8">
			Tell us your phone number so one of our agents can reach you
		</h3>

		<form class="dialog-form-demo">
			<Input isRounded label="Phone (required)" type="phone" id="phone" placeholder="333-333-3333" required />
			<div class="mbe16" />
			<Button type="submit" mode="primary" isRounded isBlock on:click={()=>navigate("/thanks")}>
				Call me
			</Button>
			<Button type="submit" isRounded isBlock on:click={()=>show_enroll=false}>
				Back to Plan
			</Button>
		</form>
	</Modal>
{/if}